import React, { useState } from 'react';

// Formik
import { Field } from 'formik';

// Icons
import 'font-awesome/css/font-awesome.min.css';

interface Features {
    secureTextStatus?: boolean;
    name: string;
    type?: string;
    placeholder?: string;
    label?: string;
    errors?: string;
    customClasses?: string;
    additionalClasses?: string;
    frameClasses?: string;
    disabled?: boolean;
    value?: any;
}

const FunctionalTextInput: React.FC<Features> = (props) => {
    const [secureText, setSecureText] = useState(true)

    /* Default values */
    const secureTextStatus = props.secureTextStatus ?? false;
    const type = props.type !== undefined ? props.type : 'text';
    const customClasses = props.customClasses !== undefined ? props.customClasses : 'border border-gray-300 rounded w-full py-2 px-3 text-grey-darker h-10 text-sm'
    const disabled = props.disabled !== undefined ? props.disabled : false;

    return (
        <div className={props.frameClasses}>
            <div className="relative">
                {
                    props.label &&
                    <label className="block text-grey-darker text-sm font-bold mb-2">{props.label}</label>
                }

                {
                    !disabled ?
                        <Field
                            className={customClasses + ' ' + props.additionalClasses}
                            name={props.name}
                            type={secureTextStatus && secureText ? 'password' : type}
                            placeholder={props.placeholder}
                        />
                        :
                        <div
                            className={customClasses + ' ' + props.additionalClasses}
                        >
                            {props.value}
                        </div>
                }

                {
                    secureTextStatus &&
                    <div onClick={() => setSecureText(!secureText)} className="cursor-pointer absolute top-0 h-full flex justify-center items-center right-2">
                        <i className={`fa fa-eye ${props.label === undefined ? null : 'mt-7'}`}></i>
                    </div>
                }
            </div>
            {
                props.errors &&
                <div className="text-red-500 mt-1 text-sm">{props.errors}</div>
            }
        </div>
    )
}

export default FunctionalTextInput;